import { Bar } from '@ant-design/plots';
import React from 'react';
import ReactDOM from 'react-dom';

const DemoBar = () => {
  const data = [
    { year: '2001', gender: 'male', count: 70 },
    { year: '2001', gender: 'female', count: 30 },
    { year: '2002', gender: 'male', count: 80 },
    { year: '2002', gender: 'female', count: 20 },
    { year: '2003', gender: 'male', count: 60 },
    { year: '2003', gender: 'female', count: 40 },
    { year: '2004', gender: 'male', count: 80 },
    { year: '2004', gender: 'female', count: 30 },
    { year: '2005', gender: 'male', count: 70 },
    { year: '2005', gender: 'female', count: 30 },
    { year: '2006', gender: 'male', count: 80 },
    { year: '2006', gender: 'female', count: 20 },
    { year: '2007', gender: 'male', count: 70 },
    { year: '2007', gender: 'female', count: 30 },
    { year: '2008', gender: 'male', count: 60 },
    { year: '2008', gender: 'female', count: 40 },
    { year: '2009', gender: 'male', count: 65 },
    { year: '2009', gender: 'female', count: 35 },
    { year: '2010', gender: 'male', count: 70 },
    { year: '2010', gender: 'female', count: 30 },
    { year: '2011', gender: 'male', count: 80 },
    { year: '2011', gender: 'female', count: 20 },
    { year: '2012', gender: 'male', count: 70 },
    { year: '2012', gender: 'female', count: 30 },
];
  const config = {
    data,
    theme: "classicDark",
    height: 240,
    xField: 'year',
    yField: 'count',
    colorField: 'gender',
    stack: true,
    normalize: true,
    sort: {
      reverse: true,
      by: 'y',
    },
    axis: {
      y: { labelFormatter: '~s' },
      x: {
        labelSpacing: 4,
        style: {
          labelTransform: 'rotate(90)',
        },
      },
    },
    tooltip: { items: [{ channel: 'y0', valueFormatter: '.0%' }] },
  };
  return <Bar {...config} />;
};

export default DemoBar;
